import {
  Maybe as HygraphMaybe,
  VerticalAlign as HygraphVerticalAlign,
} from '@/lib/types';

import { VerticalAlignment } from '@/enums/vertical-alignment';

export default function verticalAlignmentTransformer(
  props: HygraphMaybe<HygraphVerticalAlign> | undefined
) {
  switch (props) {
    case HygraphVerticalAlign.Top:
      return VerticalAlignment.TOP;
    case HygraphVerticalAlign.Middle:
      return VerticalAlignment.MIDDLE;
    case HygraphVerticalAlign.Bottom:
      return VerticalAlignment.BOTTOM;
    default:
      return undefined;
  }
}
